export default function Button({ label, color, outline = false, tel = false, href = "#" }) {
    const telIcon = <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" >
        <path fillRule="evenodd" clipRule="evenodd" d="M14.6877 19.9674C13.2477 19.9144 9.16674 19.3504 4.89274 15.0774C0.619742 10.8034 0.056742 6.72344 0.002742 5.28244C-0.077258 3.08644 1.60474 0.953444 3.54774 0.120444C3.78172 0.019411 4.03794 -0.0190554 4.29127 0.0088196C4.5446 0.0366946 4.78633 0.129953 4.99274 0.279444C6.59274 1.44544 7.69674 3.20944 8.64474 4.59644C8.85333 4.90117 8.94251 5.27199 8.8953 5.63824C8.84809 6.00449 8.66778 6.34057 8.38874 6.58244L6.43774 8.03144C6.34348 8.09951 6.27713 8.19947 6.25102 8.31277C6.2249 8.42606 6.24079 8.54498 6.29574 8.64744C6.73774 9.45044 7.52374 10.6464 8.42374 11.5464C9.32374 12.4464 10.5767 13.2844 11.4357 13.7764C11.5434 13.8369 11.6702 13.8538 11.79 13.8237C11.9098 13.7935 12.0135 13.7187 12.0797 13.6144L13.3497 11.6814C13.5832 11.3713 13.9277 11.1635 14.3109 11.1016C14.6942 11.0397 15.0865 11.1285 15.4057 11.3494C16.8127 12.3234 18.4547 13.4084 19.6567 14.9474C19.8184 15.1553 19.9212 15.4029 19.9544 15.6641C19.9877 15.9253 19.9501 16.1907 19.8457 16.4324C19.0087 18.3854 16.8907 20.0484 14.6877 19.9674Z" />
    </svg>

    if (label === "06 76 22 64 73" || tel || label === "Appelez-nous") {
        href = "tel:+33676226473"
    } else if (label === "Envoyez un mail" || label === "contact@maestrom-digital.fr") {
        href = "mailto:contact@maestrom-digital.fr"
    }

    return (
        <>
            <a href={href} className={`f16 btn btn-${color} ${outline ? 'outline' : ''} ${tel ? 'tel' : ''}`}>
                <p>
                    {tel && (
                        <span>
                            {telIcon}
                        </span>
                    )}
                    {label}
                </p>
            </a>
        </>
    )
} 